// Light mode
export const light = {
  alternate: {
    main: '#F3F6FC',
    dark: '#EBF0F9',
  },
  cardShadow: 'rgba(0, 0, 0, 0.08)',
  mode: 'light' as const,
  primary: {
    main: '#1F1B56', // Similar to cahda primary
    light: '#4A83E6',
    dark: '#102366',
    contrastText: '#ffffff',
  },
  secondary: {
    main: '#0284c7', // Insurance blue
    light: '#38bdf8',
    dark: '#0369a1',
    contrastText: '#ffffff',
  },
  text: {
    primary: '#1C1E22',
    secondary: '#58687E',
  },
  divider: 'rgba(0, 0, 0, 0.1)',
  background: {
    paper: '#FFFFFF',
    default: '#F7FAFC',
    level2: '#F1F5FA',
    level1: '#FFFFFF',
  },
};

// Dark mode
export const dark = {
  alternate: {
    main: '#20273C',
    dark: '#171C2B',
  },
  cardShadow: 'rgba(0, 0, 0, 0.2)',
  mode: 'dark' as const,
  primary: {
    main: '#1976D2',
    light: '#2196F3',
    dark: '#0D47A1',
    contrastText: '#ffffff',
  },
  secondary: {
    main: '#0ea5e9', // Insurance blue light
    light: '#38bdf8',
    dark: '#0284c7',
    contrastText: '#ffffff',
  },
  text: {
    primary: '#EDEFF2',
    secondary: '#A8ADB8',
  },
  divider: 'rgba(255, 255, 255, 0.1)',
  background: {
    paper: '#2C2F3B',
    default: '#222831',
    level2: '#333842',
    level1: '#2C2F3B',
  },
};
